import React from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay, HStack
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectTrayOpen, selectTrayOptions, selectTrayProps, selectTrayTitleComponent } from '../../../redux/modules/tray';

const TrayContainer = ({ children }) => {
  const { size, placement, title, onClose, overlayClose, motionPreset, variant } = useSelector(selectTrayOptions);
  const props = useSelector(selectTrayProps);
  const isOpen = useSelector(selectTrayOpen);
  const TitleComponent = useSelector(selectTrayTitleComponent);

  return (
    <Drawer
      closeOnOverlayClick={overlayClose}
      isOpen={isOpen}
      motionPreset={motionPreset}
      placement={placement}
      size={size}
      variant={variant}
      onClose={() => onClose(props)}
    >
      <DrawerOverlay>
        <DrawerContent>
          {title && (
            <>
              <DrawerCloseButton dusk="drawerCloseButton" />
              <DrawerHeader>
                <HStack>
                  <Box mr={4}>
                    {title}
                  </Box>
                  {TitleComponent && (<TitleComponent />)}
                </HStack>
              </DrawerHeader>
            </>
          )}
          {children}
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

TrayContainer.propTypes = { children: PropTypes.element };

export default TrayContainer;
